import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { ThemeProvider } from "./theme/ThemeProvider";
import { WorkspaceProvider } from "./app/WorkspaceContext";
import { AskNaraProvider } from "./app/AskNara";
import { AppAuthProvider } from "./auth/oidc";
import { queryClient } from "./lib/query";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AppAuthProvider>
          <ThemeProvider>
            <WorkspaceProvider>
              <AskNaraProvider>
                <App />
              </AskNaraProvider>
            </WorkspaceProvider>
          </ThemeProvider>
        </AppAuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
